import{jsx as r}from"react/jsx-runtime";import{styled as e}from"styled-components";const o=e.div`
  font:
    12px/18px 'Lucida Grande',
    'Lucida Sans Unicode',
    Helvetica,
    Arial,
    Verdana,
    sans-serif;
  min-height: 64px;
  overflow: auto;

  border: 1px solid #999999;
  border-top: 0px;
  box-shadow: 2px 2px 2px #888888;

  border-radius: 3px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  background: url('images/support_back.png') transparent;
`;function t({height:e,children:t,style:i,...p}){return r(o,{style:{...i,height:e,maxHeight:e},...p,children:t})}export{t as TabPanel};
